// 
import React from "react";
import "./banner.css";

const Banner = () => {
  return (
    <section className="banner">
      <div className="banner-content">
        <h2>Looking for a Web Developer or IoT Expert?</h2>
        <p>
          I help businesses and startups build modern <strong>web applications</strong> and innovative <strong>IoT solutions</strong>. From custom websites to connected devices, I turn your ideas into reality.
        </p>
        <a href="#contact" className="btn-primary">
          Let’s Work Together →
        </a>
      </div>
    </section>
  );
};

export default Banner;
